import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsUpChevron: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M15 7v9L8 9l-7 7V7l7-7z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsUpChevron
